// interfaces / types / consts
const API_KEY = process.env.REACT_APP_REST_API_KEY || '';
const BASE_URL = process.env.REACT_APP_REST_API_BASE_URL || '';
interface IAPIQuestCost {
  amount: string;
  cost_type: string;
}
interface IAPIQuestReward {
  amount: string;
  reward_type: string;
  min_chance: number;
  max_chance: number;
  min_threshold: number;
  max_threshold: number;
}
interface IAPIQuest {
  id: string;
  title: string;
  duration: string;
  dangerous: boolean;
  costs: IAPIQuestCost[];
  rewards: IAPIQuestReward[];
  points: { heroes: number[]; traits: number[][] };
  traits: { id: string; type: string; value: string }[][];
  text_intro: string;
  message_mid: string;
  message_fail: string;
  message_success: string;
  pin_id?: string;
}
type IAPIQuestsRes = { [key: string]: IAPIQuest };
interface IConfig {
  items: unknown;
  world: unknown;
  traits: unknown;
  genericTexts: unknown;
  campaignQuests: IAPIQuestsRes;
}

// exports
export type IAPIQuests = IAPIQuestsRes;
export const get = (): Promise<IConfig> => fetch(`${BASE_URL}/game/config`, {
  headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
}).then((response) => {
  if (response.status === 200) { return response.json(); }
  return response.json().then((errMsg) => Promise.reject(errMsg));
});
export const getSideQuests = (questIds: string[] = []): Promise<IAPIQuests> => {
  if (questIds.length === 0) { return Promise.resolve({}); }
  const queryString = `?questIds=${encodeURIComponent(JSON.stringify(questIds))}`;
  return fetch(`${BASE_URL}/game/config${queryString}`, {
    headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
  }).then((response) => {
    if (response.status === 200) { return response.json(); }
    return response.json().then((errMsg) => Promise.reject(errMsg));
  });
};
export default { get, getSideQuests };
